import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { SharedSeries } from 'src/app/models/dashboard';
import { MultiSourceMultiValueWidget } from "../../base/MultiSourceMultiValueWidget";
import { HttpHeaders,HttpClient } from '@angular/common/http';

declare var require: any
var jp = require('jsonpath');
    

@Component({
  selector: 'app-free-text-widget',
  templateUrl: './free-text-widget.component.html',
  styleUrls: ['./free-text-widget.component.css']
})
export class FreeTextWidgetComponent extends MultiSourceMultiValueWidget  {
  @ViewChild('dynamicTemplate') dynamicTemplate: ElementRef;

  html:string;
  _data:any;

  liveDataOnly(): boolean {
    return (<any>this.widget).period == null || (<any>this.widget).period == "";
  }

  override eventTypes: string[]; 
  override timeSeriesEvent(type: string, uri: string): void {
    
  }

  override widgetDataLoadComplete(): void {
      
  }

  widgetBeforeInit(): void {
    this.w = <any>this.widget;
    this.html = this.w.html;
  }

  widgetAfterInit(): void {
    if (this.dynamicTemplate){
      (this.dynamicTemplate as any).set(this._data);
    }
  }

  widgetDataLoadTimeout(){
    
  }

  widgetDataLoaded(series: SharedSeries): void {
     if (series == null || series.values == null) {
      this._data = null;
    } else {
      var last = series.values == null ? null : series.values[series.values.length-1];    
      if (last != null && typeof last.value == "string" && last.value.startsWith("{")){
        this._data = { series: series, data: JSON.parse(last.value), latitude: series.latitude, longitude: series.longitude, metaData: series.metaData };
      }     
      else {
        this._data = { series: series, data: last?.value, latitude: series.latitude, longitude: series.longitude, metaData: series.metaData };
      }
      console.log("data", this._data);
      //console.log("Free Text Data", this.data);
      // load the template
      if (this.dynamicTemplate){
        (this.dynamicTemplate as any).set(this._data);
      }
    }
  }

  widgetLiveDataLoaded(point: any): void {
    var series:SharedSeries = {} as SharedSeries;
    series.values = [];
    series.values.push(point.point);
    this.widgetDataLoaded(series);
  }

  w: any;
}